import { Typography, Paper } from '@mui/material';

function EmptyState({ title, text, action }) {
  return (
    <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: action ? 2 : 0 }}>{text}</Typography>
      {action}
    </Paper>
  );
}

export default EmptyState;
